<template lang="pug">
    .main-container
        ManagementPage.scrollable(:title="$t(`${baseTranslationPath}.name`)"
                  @fetchData="loadList"
                  :searchPageSize="searchPageSize",
                  @openEditor="openEditor"
                  :showTotals="true"
                  :teamFilter="false"
                  :creatable="canView('/iqtools/forms/new')"
                  :creationTooltipContent="$t(`${baseTranslationPath}.add_form`)"
                  :pagination="pagination"
                  ref="managementPage")
          router-view(v-slot:editor)
          template(v-slot:body)
            aiq-table.manage-documents-scrollbar(:data="items" v-loading="loading")
              aiq-table-column(:label="$t(`${baseTranslationPath}.table_name`)"
                              label-class-name="is-bordered"
                              min-width="40"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.name }}
              aiq-table-column(:label="$t(`${baseTranslationPath}.form_status`)"
                              label-class-name="is-bordered"
                              min-width="40"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.status }}
              aiq-table-column(:label="$t(`${baseTranslationPath}.questions`)"
                              label-class-name="is-bordered"
                              min-width="40"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.questions_count }}
              aiq-table-column(:label="$t(`${baseTranslationPath}.last_updated`)"
                              label-class-name="is-bordered"
                              min-width="40"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.updated_at }}
              aiq-table-column(width="40", label-class-name="is-bordered" min-width="40")
                template(v-slot:default="scope")
                   aiq-button(v-if="canView('/iqtools/forms/:number')"
                   type="primary" size="small", @click="openEditor(scope.row)") {{ $t(`${baseTranslationPath}.manage`) }}
</template>
<script>
import get from 'lodash/get';
import { mapState } from 'vuex';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
const SEARCH_PAGE_SIZE = 25;

export default {
  name: 'Forms',
  components: {
    ManagementPage,
  },
  data() {
    return {
      searchPageSize: SEARCH_PAGE_SIZE,
      pagination: PAGINATION_DEFAULT,
      baseTranslationPath: 'iq_tools_tab.forms_tab.manage',
    };
  },
  computed: {
    ...mapState({
      items: state => state.agentForms.agentForms,
    }),
  },
  methods: {
    async loadList({ searchTerm, searchOffset }) {
      const params = {
        limit: this.searchPageSize,
        query: searchTerm,
        offset: searchOffset,
      };

      const response = await this.$store.dispatch(
        'agentForms/getAgentForms',
        [params, searchOffset === 0],
      );
      this.pagination = get(response, 'data.pagination', PAGINATION_DEFAULT);
      return response;
    },
    openEditor(record = {}) {
      const id = get(record, 'id', 'new');
      const path = `${this.$route.path}/${id}`;
      this.$router.push({
        path,
      });

    },
  },
};
</script>